export default {
  "parseCsr": {
    "pageTitle": "解析 CSR",
    "title": "解析 CSR",
    "subtitle": "",
    "placeholder": "在此处粘贴您 PEM 的格式 CSR",
    "summary": [
      "证书解析与查看，可以通过上传ECC、RSA、SM2等算法的CSR文件或粘贴BASE64编码查看CSR的详细信息。",
      "Certflare.com 提供的证书工具供所有用户免费使用，Certflare 不记录任何信息，用户在使用证书工具中、使用证书工具后产生的任何错误或造成任何损失，Certflare 不承担任何责任。"
    ]
  }
}
